import * as React from 'react';
import { BaseComponent, BaseComponentProps, BaseComponentState } from '../../base/BaseComponent'; 
import { getAjaxhelper } from 'src/utils';
 
export interface HotelMounthlySpecialProps extends BaseComponentProps { 
    lang: string;
}
export interface HotelMounthlySpecialState extends BaseComponentState { 
    data: string;
    requesting: boolean;
}

export class HotelMounthlySpecial extends BaseComponent<HotelMounthlySpecialProps, HotelMounthlySpecialState> {

    constructor(props: HotelMounthlySpecialProps) {
        super(props);
        this.state = {
            data: '', requesting: false
        };
    }
 
    getData = () => {
        // /dynamics/hb-api/monthly-special-hotel
        getAjaxhelper().get(`/dynamics/hb-api/monthly-special-hotel/${this.props.lang}`).then(
            (data: any) => { 
                this.setState({ requesting: false, data });
            }).catch((exc) => { console.error('error: ', exc); });
    }

    componentDidMount() {
        this.getData();
    }

    getCmsContent: (x: any) => any = (x: any) => {
        return { __html: x };
    }
    render() {
        if ( this.state.haveReactError ) {
            return this.renderErrorPanel() ; 
        } 
        return (
            <div>
                <div dangerouslySetInnerHTML={this.getCmsContent(this.state.data)} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/hotels/details/HotelMounthlySpecial.tsx